import { Routes } from '@angular/router';
import { AuthGuardService } from '../guards/auth-guard.service';
import { SettingsComponent } from './settings.component';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    canActivate: [ AuthGuardService ],
    children: [
      {
        path: '',
        component: SettingsComponent
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/app/settings/settings.routes.ts